const iconSlotSpace = "xxsmall";
export {
  iconSlotSpace
};
